module.exports = __webpack_public_path__ + "img/payroll07.a4d24c22.jpeg";